import { LOCATION_CHANGE } from 'connected-react-router'
import { createMiddleware, EventsMapper } from 'redux-beacon'
import { getType } from 'typesafe-actions'
import {
  hideCheggAuthModal,
  showCheggAuthModal,
  SIGN_IN_SUCCESS,
  SIGN_UP_SUCCESS,
  VIEW_AUTH_SIGN_IN_MODE,
  VIEW_AUTH_SIGN_UP_MODE,
} from '../auth/actions'
import {
  CARD_STATE_ACCEPT,
  CARD_STATE_READ,
  CARD_STATE_REJECT,
  CHECK_START,
  GET_CHECK_FAIL,
  GET_CHECK_SUCCESS,
  PARTIAL_PLAGIARISM_CHECK_END,
  PARTIAL_PLAGIARISM_CHECK_START,
} from '../checks/actions'
import { DOCUMENT_READY } from '../document/actions'
import { hideModal, showModal } from '../modals/actions'
import { paymentSuccess } from '../payment/actions'
import {
  USER_COMPONENT_VIEW,
  USER_INTERACTION,
  USER_NOTIFY,
  USER_SUCCESS,
} from '../userevents/actions'
import { AF_SEND_HIDDEN_CARDS, AF_SEND_NEW_CARDS } from './actions'
import {
  cardInteractionEvent,
  clickstreamComponentViewEvent,
  clickstreamInteractionEvent,
  clickstreamNotificationsEvent,
  clickStreamSignInStartEvent,
  clickStreamSignInSuccessEvent,
  clickStreamSignUpStartEvent,
  clickStreamSignUpSuccessEvent,
  clickstreamSuccessEvent,
  hideModalEvent,
  locationChangeEvent,
  paperCheckEndEvent,
  paperCheckStartEvent,
  paperReadyEvent,
  partialPlagiarismCheckEndEvent,
  partialPlagiarismCheckStartEvent,
  paymentSuccessEvent,
  sendHiddenCardsEvent,
  sendNewCardsEvent,
  showCheggAuthModalEvent,
  showModalEvent,
} from './definitions'
import RioAnalytics from './rioAnalytics'

const wta = RioAnalytics()

export const eventsMap: EventsMapper = action => {
  try {
    switch (action.type) {
      case USER_NOTIFY: {
        return clickstreamNotificationsEvent
      }
      case USER_INTERACTION: {
        return clickstreamInteractionEvent
      }
      case USER_COMPONENT_VIEW: {
        return clickstreamComponentViewEvent
      }
      case USER_SUCCESS: {
        return clickstreamSuccessEvent
      }
      case PARTIAL_PLAGIARISM_CHECK_START: {
        return partialPlagiarismCheckStartEvent
      }
      case PARTIAL_PLAGIARISM_CHECK_END: {
        return partialPlagiarismCheckEndEvent
      }
      case CHECK_START: {
        return paperCheckStartEvent
      }
      case GET_CHECK_FAIL:
      case GET_CHECK_SUCCESS: {
        return paperCheckEndEvent
      }
      case DOCUMENT_READY: {
        return paperReadyEvent
      }
      case AF_SEND_HIDDEN_CARDS: {
        return sendHiddenCardsEvent
      }
      case AF_SEND_NEW_CARDS: {
        return sendNewCardsEvent
      }
      case getType(showModal): {
        return showModalEvent
      }
      case getType(showCheggAuthModal): {
        return showCheggAuthModalEvent
      }
      case getType(paymentSuccess): {
        return paymentSuccessEvent
      }
      case LOCATION_CHANGE: {
        return locationChangeEvent
      }
      case getType(hideCheggAuthModal):
      case getType(hideModal): {
        return hideModalEvent
      }
      case CARD_STATE_ACCEPT:
      case CARD_STATE_READ:
      case CARD_STATE_REJECT: {
        return cardInteractionEvent
      }
      case SIGN_IN_SUCCESS: {
        return clickStreamSignInSuccessEvent
      }
      case SIGN_UP_SUCCESS: {
        return clickStreamSignUpSuccessEvent
      }
      case VIEW_AUTH_SIGN_IN_MODE: {
        return clickStreamSignInStartEvent
      }
      case VIEW_AUTH_SIGN_UP_MODE: {
        return clickStreamSignUpStartEvent
      }
      default:
        return []
    }
  } catch (e) {
    return []
  }
}

export const wtaMiddleware = createMiddleware(eventsMap, wta)



// WEBPACK FOOTER //
// ./src/state/analytics/index.ts